import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import PersonSearchMarriageNonResidentNotificationsShared from 'shell/components/shared/research-notifications/research-marriage-non-resident/edit-person-search';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface PersonSearchMarriageNonResidentNotificationsCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const PersonSearchMarriageNonResidentNotificationsCivilStatusShared = ({
  scope,
  items,
}: PersonSearchMarriageNonResidentNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/matrimonio/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <PersonSearchMarriageNonResidentNotificationsShared
        redirectUrl={redirectUrl}
        goBackUrl={`${goBackUrl}/matrimonio/non-residenti`}
        items={items}
      />
    </Fragment>
  );
};

PersonSearchMarriageNonResidentNotificationsCivilStatusShared.displayName =
  'Research Marriage Non Resident Notifications CivilStatusShared component';

export default PersonSearchMarriageNonResidentNotificationsCivilStatusShared;
